import React, { useEffect ,useCallback, useState } from "react";

export default function UseCallBack() {
  const [num, setNum] = useState(0);
  const [name, setName] = useState("");

  useEffect(() => {
      
  })

  return (
    <>
      <div className="container">
        <p style={{ textAlign: "left" }}>
          <b>
            useCallback Hook is to stop Re-Creating an object during every
            render or re-render.
          </b>
          <br />
          <br />
          This looks similar to useEffect Hook but there is a difference :
          useEffect() runs after every render cycle (i.e. whenever our
          functional component re-runs/ re-renders), unless we pass a second
          argument to an array of dependencies of the effect whereas useCallback
          Hook prevents recreation of an object (function) in re-renders when
          there is no dependency array specified.
          <br />
          <br />
          <div className="row" style={{ textAlign: "left" }}></div>
        </p>
        <div className="row">
          <p></p>
        </div>

        {/* <div className="row">
          <input
            className="form-control"
            type="text"
            onChange={(e) => setName(e.target.value)}
          ></input>
          {name} ---- {num}
        </div> */}
        <div className="row">
          <p></p>
        </div>
        <div className="col-md-4"></div>
      </div>
    </>
  );
}
